<form
  [formGroup]="auth_signin_form_group"
  class="hmn-form__standalone">
  <mat-form-field
    class="hmn-width__full hmn-form-field__primary-contrast"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.EMAIL_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="email"
      formControlName="email"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__full hmn-form-field__primary-contrast"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'AUTH.PASSWORD_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      [type]="is_password_visible ? 'text' : 'password'"
      formControlName="password"
      [errorStateMatcher]="error_matcher"
      required />
    <mat-icon
      matSuffix
      class="sp-color__accent-contrast sp-cursor__pointer"
      (click)="is_password_visible = !is_password_visible">
      {{ is_password_visible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
  </mat-form-field>

  <h6
    style="margin-top: -8px"
    class="hmn-width__full hmn-color__primary hmn-text__right hmn-text__hover">
    {{ 'AUTH.FORGOT_PSS_CTA' | translate }}
  </h6>

  <app-shared-button
    class="hmn-margin__x8-top hmn-display__block"
    [button_cta]="'AUTH.SIGNIN_CTA'"
    [button_class]="'hmn-button__main-contrast hmn-width__full'"
    [button_cta_class]="'hmn-text__5'"
    (button_click)="onSigninClick()"></app-shared-button>

  <app-shared-button
    class="hmn-margin__x4-top hmn-display__block"
    [button_cta]="'AUTH.SIGNUP_REDIRECT_CTA'"
    [button_class]="'hmn-button__secondary-accent hmn-width__full'"
    [button_cta_class]="'hmn-text__5'"
    (button_click)="onSignupRedirectClick()"></app-shared-button>
</form>
